import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SystemStatusPageComponent } from './features/system-status-page/system-status-page.component';

@Component({
  selector: 'fv-status-page-app-root',
  standalone: true,
  imports: [SystemStatusPageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<fv-system-status-page />',
})
export class AppComponent {}
